import { memo, useEffect } from "react";
import { MiExpandableBox } from "@miplatform/components";
import { EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP } from "@miplatform/constants";
import {
  EmailTemplateType,
  IEmailTemplateResponse,
  IOrder,
  IOrderInfo,
} from "@miplatform/types";
import { MiEmailInfoCard } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { useOrdersContext } from "../../../OrdersProvider";
import { useOrderInfoCardEmailsViewModel } from "./useOrderInfoCardEmailsViewModel";

interface OrderInfoCardEmailsProps {
  order: IOrder | IOrderInfo;
  onClose?: () => void;
}

export const OrderInfoCardEmails = memo(
  ({ order, onClose }: OrderInfoCardEmailsProps) => {
    const { handleEmailDrawerOpen, handleEmailPreviewModalOpen } =
      useOrdersContext();
    const {
      emailHistory,
      emailTemplates,
      getEmailTemplateDetails,
      getEmailHistory,
    } = useOrderInfoCardEmailsViewModel();

    useEffect(() => {
      getEmailHistory(
        (order as IOrder).id || ((order as IOrderInfo).orderId as string)
      );
      getEmailTemplateDetails(order.orderTemplateId as string);
    }, [order]);

    return (
      emailTemplates.length > 0 && (
        <MiExpandableBox defaultExpanded title="Emails" sx={{ pt: 2 }}>
          <Box
            position="relative"
            display="flex"
            flexDirection="column"
            gap={1}
          >
            {(emailTemplates as IEmailTemplateResponse[]).map(
              (emailTemplate) => (
                <MiEmailInfoCard
                  key={emailTemplate.emailType}
                  title={
                    EMAIL_TEMPLATE_TYPE_TO_LABEL_MAP[
                      emailTemplate.emailType as EmailTemplateType
                    ]
                  }
                  lastSent={
                    emailHistory[emailTemplate.emailType as EmailTemplateType]
                      ?.createdOn
                  }
                  isViewDisabled={
                    !emailHistory[emailTemplate.emailType as EmailTemplateType]
                  }
                  onViewClick={() => {
                    handleEmailPreviewModalOpen(
                      emailHistory[emailTemplate.emailType as EmailTemplateType]
                    );
                    onClose?.();
                  }}
                  onActionClick={() => {
                    handleEmailDrawerOpen({
                      order,
                      templateType: emailTemplate.emailType,
                    });
                    onClose?.();
                  }}
                />
              )
            )}
          </Box>
        </MiExpandableBox>
      )
    );
  }
);
